import type { DiagnosisUnlockTopNavConfig } from "../types";

/**
 * Step3 顶栏图标 — H5 / PC 分端（Figma 不一致）。
 *
 * - H5 `90772:39962` / `40004` / `13734`：`back` → ←
 * - PC `90772:43126`：`close` 实例（右上），行为仍为 `previous_step`
 */
export function resolveUnlockStepTopNavIconName(
  isPc: boolean,
  topNav: DiagnosisUnlockTopNavConfig,
): "close" | "left-arrow-alt" {
  if (topNav.variant === "none") {
    return "close";
  }

  if (isPc) {
    return "close";
  }

  return topNav.variant === "close" ? "close" : "left-arrow-alt";
}

export function resolveUnlockStepTopNavAriaLabel(
  isPc: boolean,
  topNav: DiagnosisUnlockTopNavConfig,
): string {
  if (topNav.variant === "none") {
    return "Close";
  }

  if (topNav.behavior === "previous_step") {
    return isPc ? "Back to diagnosis" : "Back";
  }

  return "Close";
}
